const _import = require('../import-' + process.env.NODE_ENV)

const shelvesDataRouter = [
  {
    path: '/shelvesData/write',
    name: 'shelvesDataWrite',
    component: _import('shelvesData/write'),
    meta: {
      title: '排面参数录入',
      auth: true
    }
  }
]
export default shelvesDataRouter



// WEBPACK FOOTER //
// ./src/router/work/shelvesData.js